import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearCurrentPage,
  getApiParams,
} from "../../../NetworkPortal/ProviderProfileDetails/helper";
import { useEffect } from "react";
import {
  CSVData,
  TestExcelHeader,
  TestExcelHeaderColmns,
  initialFilterState,
  initialHeaderTest,
} from "./helper";
import Modal from "react-modal";
import {
  getSkuPackagesAction,
  getSKUPackageExcelAction,
} from "../../../../redux/actions/TestPackagesAction";
import { ExcelIconTest, SearchIcon } from "../../../../Utils/SvgIcons";
import { ChooseToFilterPackagePopup } from "./ChooseToFilterPackagePopup";
import { UploadExcelPackagePopup } from "./UploadExcelPackagePopup";
import { AddQuicklyPackageSKUPopup } from "./AddQuicklyPackageSKUPopup";
import PaginatedItems from "../../../../common/Pagination";
import { isLoadingAction } from "../../../../Utils/helper";
import { CSVLink } from "react-csv";
import {
  SubmitApprovalRequestAction,
  ViewRequestStatusAction,
} from "../../../../redux/actions/GlobalAction";

const Packages = () => {
  const dispatch = useDispatch();
  const [showHeaderTestArray, setShowHeaderTestArray] =
    useState(initialHeaderTest);
  const [excelSheetData, setExcelSheetData] = useState([]);
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const [userDetail, setUserDetail] = useState(null);
  const [searchFilter, setSearchFilter] = useState(initialFilterState);
  const [isAddSku, setIsAddSku] = useState(false);
  const [providerPackageMapStgId, setProviderPackageMapStgId] = useState(null);
  const [providerPackageId, setProviderPackageId] = useState(null);
  const [packageId, setPackageId] = useState(null);
  const [isChooseToFilter, setIsChooseToFilter] = useState(false);
  const [isUploadExcel, setIsUploadExcel] = useState(false);

  const TestPackageReducer = useSelector((state) => state?.TestPackageReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const { apiParams } = getApiParams({ globalReducer });

  useEffect(() => {
    dispatch(getSkuPackagesAction({ ...searchFilter, ...apiParams }));
  }, [globalReducer?.getCurrentPage]);

  const handleSearch = () => {
    clearCurrentPage(dispatch);
    dispatch(getSkuPackagesAction({ ...searchFilter, ...apiParams, page: 1 }));
  };

  const changeHandler = (name, value) => {
    setSearchFilter({ ...searchFilter, [name]: value });
  };

  const handleClearFilter = () => {
    setSearchFilter(initialFilterState);
    dispatch(getSkuPackagesAction(initialFilterState));
    clearCurrentPage(dispatch);
  };

  const ExportToExcelHandler = async () => {
    setIsLoadingExcel(true);
    const resp = dispatch(
      getSKUPackageExcelAction({
        centrePackageCode: searchFilter?.centrePackageCode,
        centrePackageName: searchFilter?.centrePackageName,
        requeststatus: searchFilter?.RequestStatus,
        sortDirection: "desc",
      })
    );
    resp?.then((res) => {
      if (res?.data?.status === true) {
        setExcelSheetData(res?.data?.results?.lstPackageDetails);
        setIsLoadingExcel(false);
      } else {
        setIsLoadingExcel(false);
      }
      setTimeout(() => {
        document.getElementById("exportexcel").click();
      }, 500);
    });
  };

  return (
    <>
      <div className="row-filter">
        <input
          type="text"
          placeholder="Package Name"
          className="white-form-select"
          value={
            searchFilter?.centrePackageName === null
              ? ""
              : searchFilter?.centrePackageName
          }
          onChange={(e) => changeHandler("centrePackageName", e.target.value)}
          onKeyPress={(event) => {
            if (event.key === "Enter") {
              handleSearch(event);
            }
          }}
        />
        <input
          type="text"
          className="white-form-select"
          placeholder="Package Code"
          value={
            searchFilter?.centrePackageCode === null
              ? ""
              : searchFilter?.centrePackageCode
          }
          onChange={(e) => changeHandler("centrePackageCode", e.target.value)}
          onKeyPress={(event) => {
            if (event.key === "Enter") {
              handleSearch(event);
            }
          }}
        />
        <select
          style={{ padding: "8px" }}
          name="gender"
          className="white-form-select"
          value={
            searchFilter?.RequestStatus === null
              ? ""
              : searchFilter?.RequestStatus
          }
          onChange={(e) => changeHandler("RequestStatus", e.target.value)}
        >
          <option value="">Select Status</option>
          <option value="UnMapped">UnMapped</option>
          <option value="Not Submitted">Not Submitted</option>
          <option value="Pending For Approval">Pending For Approval</option>
          <option value="Accepted">Accepted</option>
          <option value="Rejected">Rejected</option>
        </select>
        <div className="search" type="button" onClick={handleSearch}>
          <a className="sidebar-links">
            <SearchIcon />
            <span className="sidebar-link-text" style={{ color: "white" }}>
              Search
            </span>
          </a>
        </div>
        <div className="search" type="button" onClick={handleClearFilter}>
          <a className="sidebar-links">
            <span className="sidebar-link-text" style={{ color: "white" }}>
              Clear All
            </span>
          </a>
        </div>
      </div>
      <div className="row-results">
        <div className="results">
          Total <span>{globalReducer?.getTotalCount}</span> results
        </div>
        <div className="d-flex gap-10">
          <button
            className={`btn search__btn`}
            type="button"
            onClick={() => setIsAddSku(true)}
          >
            <i className="fa-solid fa-plus pt-1 c-white"></i>&nbsp;
            {window.innerWidth <= 700 ? "Add" : " Quickly Add Package"}
          </button>
          <button
            className={`btn ${
              !isLoadingExcel ? "search__btn" : "disabled_btn"
            }`}
            type="button"
            onClick={ExportToExcelHandler}
          >
            <i className="fa-solid fa-arrow-down"></i>&nbsp;
            {isLoadingExcel
              ? window.innerWidth <= 700
                ? "Export"
                : "Exporting..."
              : window.innerWidth <= 700
              ? "Excel"
              : "Export To Excel"}
          </button>
          <CSVLink
            style={{ display: "none" }}
            id="exportexcel"
            data={CSVData(excelSheetData)}
            headers={TestExcelHeader}
            filename={"providerpackagedetails.csv"}
          ></CSVLink>
          <button
            className={`btn search__btn`}
            type="button"
            onClick={() => setIsUploadExcel(true)}
          >
            <i className="fas fa-file-upload pt-1"></i>&nbsp;
            {window.innerWidth <= 700 ? "Import" : "Import Package"}
          </button>
        </div>
      </div>
      <div className="table-responsive __custom__properties">
        <table className="table">
          <thead>
            <tr className="avanishtbl">
              {showHeaderTestArray?.map((ele, index) => {
                return (
                  <th scope="col" key={index}>
                    {ele}
                  </th>
                );
              })}
              <th>Status</th>
              <th
                style={{ cursor: "pointer" }}
                onClick={() => setIsChooseToFilter(true)}
              >
                <img
                  src={
                    window.location.pathname.includes("campaigns")
                      ? "../../images/settings.png"
                      : "./images/settings.png"
                  }
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {TestPackageReducer?.getSkuTestPackagesDetails?.lstPackageDetails?.map(
              (ele, index) => {
                return (
                  <tr key={index}>
                    {showHeaderTestArray?.map((col) => (
                      <td>
                        {col === "Gender"
                          ? ele?.gender === "M"
                            ? "Male"
                            : ele?.gender === "F"
                            ? "Female"
                            : "Both"
                          : col === "Visit Type"
                          ? ele?.visitType === "HV"
                            ? "Home Visit"
                            : ele?.visitType === "DC"
                            ? "Centre Visit"
                            : ele?.visitType === "MIX"
                            ? "Mix Visit"
                            : "-"
                          : col === "Fasting Required"
                          ? ele?.fastingRequired
                            ? "Yes"
                            : "No"
                          : ele[TestExcelHeaderColmns[col]] === null
                          ? "-"
                          : ele[TestExcelHeaderColmns[col]]}
                      </td>
                    ))}
                    <td>
                      <span
                        className={`${
                          ele?.requestStatus === "Pending For Approval"
                            ? "pending-status"
                            : ele?.requestStatus === "Accepted"
                            ? "accepted-status"
                            : ele?.requestStatus === "Rejected"
                            ? "rejected-status"
                            : ele?.requestStatus === "UnMapped"
                            ? "unmapped-status"
                            : "notsubmited-status"
                        }`}
                      >
                        {ele?.requestStatus === null
                          ? "-"
                          : ele?.requestStatus === "Pending For Approval"
                          ? "Pending"
                          : ele?.requestStatus}
                      </span>
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setIsAddSku(true);
                        setProviderPackageMapStgId(
                          ele?.providerPackageMapStgId
                        );
                        setProviderPackageId(ele?.providerPackageId);
                        setPackageId(ele?.packageId);
                        setUserDetail(ele);
                      }}
                    >
                      <img
                        src={
                          window.location.pathname.includes("campaigns")
                            ? "../../images/edit-icon.png"
                            : "./images/edit-icon.png"
                        }
                      />
                    </td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
      </div>
      <div className="pagination-row">
        {globalReducer?.getTotalCount !== 0 && (
          <PaginatedItems
            totalCount={globalReducer?.getTotalCount}
            perPageData={searchFilter?.rows}
          />
        )}
      </div>
      <div className="mb-2 text-end">
        {TestPackageReducer?.getSkuTestPackagesDetails?.isShowSubmitButton && (
          <button
            className="btn btn-primary"
            type="button"
            onClick={async () => {
              await dispatch(SubmitApprovalRequestAction("PackageDetail"));
              dispatch(getSkuPackagesAction({ ...searchFilter, ...apiParams }));
              await dispatch(ViewRequestStatusAction("PackageDetail"));
            }}
          >
            SUBMIT
          </button>
        )}
      </div>
      <Modal
        isOpen={isAddSku}
        className="modal-add-user-popup modal-role-user-popup"
        overlayClassName="overlay-history-popup network-z-index"
        ariaHideApp={false}
      >
        <AddQuicklyPackageSKUPopup
          setIsAddSku={setIsAddSku}
          setProviderPackageMapStgId={setProviderPackageMapStgId}
          setProviderPackageId={setProviderPackageId}
          providerPackageMapStgId={providerPackageMapStgId}
          providerPackageId={providerPackageId}
          searchFilter={searchFilter}
          apiParams={apiParams}
          setPackageId={setPackageId}
          packageId={packageId}
          userDetail={userDetail}
        />
      </Modal>
      <Modal
        isOpen={isChooseToFilter}
        className="modal-add-user-popup modal-role-user-popup modal-choose-popup"
        overlayClassName="overlay-history-popup network-z-index"
        ariaHideApp={false}
      >
        <ChooseToFilterPackagePopup
          setIsChooseToFilter={setIsChooseToFilter}
          showHeaderTestArray={showHeaderTestArray}
          setShowHeaderTestArray={setShowHeaderTestArray}
        />
      </Modal>
      <Modal
        isOpen={isUploadExcel}
        className="modal-add-user-popup modal-upload-excel-popup"
        overlayClassName="overlay-history-popup network-z-index"
        ariaHideApp={false}
      >
        <UploadExcelPackagePopup setIsUploadExcel={setIsUploadExcel} />
      </Modal>
    </>
  );
};

export default Packages;
